/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface MCPSetupCommandResponse
 */
export interface MCPSetupCommandResponse {
  /**
   *
   * @type {string}
   * @memberof MCPSetupCommandResponse
   */
  command: string;
  /**
   *
   * @type {string}
   * @memberof MCPSetupCommandResponse
   */
  commandWindows: string;
}

/**
 * Check if a given object implements the MCPSetupCommandResponse interface.
 */
export function instanceOfMCPSetupCommandResponse(value: object): value is MCPSetupCommandResponse {
  if (!('command' in value) || value['command'] === undefined) return false;
  if (!('commandWindows' in value) || value['commandWindows'] === undefined) return false;
  return true;
}

export function MCPSetupCommandResponseFromJSON(json: any): MCPSetupCommandResponse {
  return MCPSetupCommandResponseFromJSONTyped(json, false);
}

export function MCPSetupCommandResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MCPSetupCommandResponse {
  if (json == null) {
    return json;
  }
  return {
    command: json['command'],
    commandWindows: json['command_windows'],
  };
}

export function MCPSetupCommandResponseToJSON(value?: MCPSetupCommandResponse | null): any {
  if (value == null) {
    return value;
  }
  return {
    command: value['command'],
    command_windows: value['commandWindows'],
  };
}
